export default "__VITE_ASSET__29216136__"